//import logo from './logo.svg';
import './App.css';
import ResizableLayout from './ResizableLayout';
import { StartDateProvider } from './StartDateContext';
import { EditBarDialogProvider } from './EditBarDialogContext';
import { CopyPasteProvider } from './CopyPasteContext';
import { CopyMoveProvider } from './CopyMoveContext';
import { LoadingProvider } from './LoadingContext';
import { ModalProvider, useModal } from './ModalContext';
import { PlanNameProvider } from './PlanNameContext';
import { HasChangesProvider } from './HasChangesContext';
import { LoginProvider, useLoginContext } from './LoginContext';
import { BatchOperationsProvider } from './BatchOperationsContext';
import { PlanMetadataProvider } from './PlanMetadataContext';
import GlobalEditBarDialog from './GlobalEditBarDialog';
import GlobalLoadingSpinner from './GlobalLoadingSpinner';
import SpecialTimesModal from './SpecialTimesModal';
import React from 'react';

const AppContent = () => {
  const [hasUnsavedChanges] = React.useState(false);
  const [isSpecialTimesModalOpen, setIsSpecialTimesModalOpen] = React.useState(false);
  const { showConfirm } = useModal();
  const { user } = useLoginContext();

  // Verhindere Refresh und zeige Warnung bei ungespeicherten Änderungen
  React.useEffect(() => {
    // Verhindere F5, Ctrl+R, Cmd+R und handle Special Times Modal
    const handleKeyDown = async (e) => {
      // Ctrl+Alt+A für Special Times Modal
      if (e.ctrlKey && e.altKey && (e.key === 'a' || e.key === 'A')) {
        e.preventDefault();
        e.stopPropagation();
        setIsSpecialTimesModalOpen(prev => !prev);
        return false;
      }
      
      // F5
      if (e.key === 'F5') {
        e.preventDefault();
        e.stopPropagation();
        
        let confirmMessage = 'Möchten Sie die Seite neu laden?';
        if (hasUnsavedChanges && user) {
          confirmMessage = 'Sie haben ungespeicherte Änderungen und sind angemeldet. Möchten Sie die Seite wirklich neu laden?';
        } else if (hasUnsavedChanges) {
          confirmMessage = 'Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich neu laden?';
        } else if (user) {
          confirmMessage = 'Sie sind angemeldet. Möchten Sie die Seite neu laden? (Sie bleiben angemeldet)';
        }
        
        const confirmed = await showConfirm({
          title: 'Seite neu laden',
          message: confirmMessage,
          confirmText: 'Neu laden',
          cancelText: 'Abbrechen'
        });
        
        if (confirmed) {
          window.location.reload();
        }
        return false;
      }
      
      // Ctrl+R oder Cmd+R (für Mac)
      if ((e.ctrlKey || e.metaKey) && (e.key === 'r' || e.key === 'R')) {
        e.preventDefault();
        e.stopPropagation();
        
        let confirmMessage = 'Möchten Sie die Seite neu laden?';
        if (hasUnsavedChanges && user) {
          confirmMessage = 'Sie haben ungespeicherte Änderungen und sind angemeldet. Möchten Sie die Seite wirklich neu laden?';
        } else if (hasUnsavedChanges) {
          confirmMessage = 'Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich neu laden?';
        } else if (user) {
          confirmMessage = 'Sie sind angemeldet. Möchten Sie die Seite neu laden? (Sie bleiben angemeldet)';
        }
        
        const confirmed = await showConfirm({
          title: 'Seite neu laden',
          message: confirmMessage,
          confirmText: 'Neu laden',
          cancelText: 'Abbrechen'
        });
          
        if (confirmed) {
          window.location.reload();
        }
        return false;
      }
    };

    // Verhindere Browser-Refresh-Button und Schließen des Tabs
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges || user) {
        e.preventDefault();
        if (hasUnsavedChanges && user) {
          e.returnValue = 'Sie haben ungespeicherte Änderungen und sind angemeldet!';
          return 'Sie haben ungespeicherte Änderungen und sind angemeldet!';
        } else if (hasUnsavedChanges) {
          e.returnValue = 'Sie haben ungespeicherte Änderungen!';
          return 'Sie haben ungespeicherte Änderungen!';
        } else if (user) {
          e.returnValue = 'Sie sind angemeldet. Beim Neuladen bleiben Sie angemeldet.';
          return 'Sie sind angemeldet. Beim Neuladen bleiben Sie angemeldet.';
        }
      }
    };

    // Event Listener hinzufügen
    document.addEventListener('keydown', handleKeyDown, true); // capture phase
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup beim Unmount
    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges, showConfirm, user]);

  return (
    <StartDateProvider>
      <EditBarDialogProvider>
        <CopyPasteProvider>
          <CopyMoveProvider>
            <LoadingProvider>
              <BatchOperationsProvider>
              <div className="App">
                <ResizableLayout
                  header={"Syllabus"}
                  left={<div>Einstellungen</div>}
                  right={<div>Lehrplan</div>}
                />
                
                {/* Global Edit Bar Dialog auf höchster Ebene */}
                <GlobalEditBarDialog />
                
                {/* Globaler Loading Spinner */}
                <GlobalLoadingSpinner />
                
                {/* Special Times Modal */}
                <SpecialTimesModal 
                  isOpen={isSpecialTimesModalOpen} 
                  onClose={() => setIsSpecialTimesModalOpen(false)} 
                />
                
              </div>
                          </BatchOperationsProvider>
            </LoadingProvider>
          </CopyMoveProvider>
        </CopyPasteProvider>
      </EditBarDialogProvider>
    </StartDateProvider>
  );
};

function App() {
  return (
    <ModalProvider>
      <LoginProvider>
        <HasChangesProvider>
          <PlanNameProvider>
            <PlanMetadataProvider>
              <AppContent />
            </PlanMetadataProvider>
          </PlanNameProvider>
        </HasChangesProvider>
      </LoginProvider>
    </ModalProvider>
  );
}

export default App;
